import { Header } from "@/components/public/header";
import { Footer } from "@/components/public/footer";
import { PublicCursor } from "@/components/public/public-cursor";
import type { ReactNode } from "react";

/** Public pages: no global grid parallax (hero handles imagery) */
export function PublicLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <PublicCursor />
      <Header />
      <main className="relative z-10 pt-[4.5rem] bg-background">{children}</main>
      <Footer />
    </>
  );
}
